const state = {
  firstLevel: 200, // 拖动弹窗浮动层级 （第一级）
  secondLevel: 100, // 拖动弹窗浮动层级 （第二级）
  userInfo: window.sessionStorage.getItem('userInfo')
    ? JSON.parse(sessionStorage.getItem('userInfo'))
    : {},
  AEPLogin: window.sessionStorage.getItem('AEPLogin')
    ? JSON.parse(sessionStorage.getItem('AEPLogin'))
    : null,
  versionConfig: []
}

const getters = {
  versionConfig(state) {
    const version = state.versionConfig?.find(
      (item) => item.module === 'dataCenter'
    )?.version

    return process.env.VUE_APP_BUILD_VERION || version || 'dispatch'
  },

  firstLevel(state) {
    return state.firstLevel
  },
  secondLevel(state) {
    return state.secondLevel
  },
  userInfo(state) {
    return state.userInfo
  },
  isLogin(state) {
    return state.userInfo.id
  },
  userToken(state) {
    return state.userInfo.token || ''
  },
  AEPLogin(state) {
    return state.AEPLogin
  }
}
const mutations = {
  // 版本配置
  setVersionConfig(state, config) {
    state.versionConfig = config
  },

  setUserInfo(state, payload) {
    state.userInfo = payload
    window.sessionStorage.setItem('userInfo', JSON.stringify(payload))
  },
  logout() {
    state.userInfo = {}
    window.sessionStorage.setItem('userInfo', '')
    window.sessionStorage.setItem('permissionList', '')
    window.sessionStorage.clear('firstLogin')
    location.reload()
  },
  setAEPLogin(state, payload) {
    state.AEPLogin = payload
    window.sessionStorage.setItem('AEPLogin', JSON.stringify(payload))
  }
}

const actions = {}

export default {
  state,
  getters,
  mutations,
  actions
}
